import { cn } from "@newxsystems/shared";
import { VelvetCardLink } from "../VelvetCardLink/VelvetCardLink";
import { VelvetMedia } from "../VelvetMedia/VelvetMedia";
import { VelvetRichText } from "../VelvetRichText/VelvetRichText";
import type { IImageContentGridBottomProps } from "./ImageContentGridBottom.props";

const columns = {
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
} as const;

export const ImageContentGridBottom = ({
  columnCount,
  imageAspectRatio,
  items,
}: IImageContentGridBottomProps) => (
  <div
    className={cn(
      "grid grid-cols-1 border-t border-parchment/50 sm:grid-cols-2",
      columns[columnCount || 3],
    )}
  >
    {items.map((item, index) => (
      <VelvetCardLink
        className="flex flex-col border-b border-parchment/20 py-8 sm:px-6 sm:first:pl-0 sm:last:pr-0"
        key={index}
        link={item.cardLink}
      >
        <div className="flex-1 pb-8 md:min-h-72 md:pb-10">
          <h3 className="font-velvet-display text-5xl font-black uppercase leading-[0.84] tracking-[-0.04em] transition-colors group-hover:text-thread">
            {item.heading}
          </h3>
          {item.description ? (
            <VelvetRichText
              className="mt-5 text-base text-smoke md:text-lg"
              content={item.description}
            />
          ) : null}
        </div>
        <VelvetMedia
          aspectRatio={imageAspectRatio || "16:9"}
          className="velvet-arch border border-parchment/20"
          media={item.image.image}
          sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
        />
      </VelvetCardLink>
    ))}
  </div>
);

ImageContentGridBottom.displayName = "Content::ImageContentGridBottom";
